import React from 'react';

import { Typography } from '@mui/material';

import { BadgeContainer } from './index.styles';

interface TopicGroupBadgeProps {
  color: string;
  label: string;
}

const TopicGroupBadge = ({ color, label }: TopicGroupBadgeProps) => (
  <BadgeContainer $color={color}>
    <Typography variant="overline">
      {label}
    </Typography>
  </BadgeContainer>
);

export default TopicGroupBadge;
